import React from 'react';
import { useHistory } from 'react-router';

import { Button } from 'src/shared/components';
import {
  useHeaderCallToAction,
  useLocation,
  useTranslate,
} from 'src/shared/hooks';
import { HeaderCallToAction } from 'src/shared/hooks/useHeaderCallToAction/enum';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Route } from 'src/shared/route';
import {
  loginStarted,
  signupStarted,
} from 'src/shared/telemetry/generated/segment';

const CallToActionButton = () => {
  const history = useHistory();
  const { search } = useLocation();

  const onLogInPress = () => history.push(Route.LOGIN.path + search);
  const onSignUpPress = () => history.push(Route.SIGN_UP.path + search);

  const headerCallToAction = useHeaderCallToAction();

  const t = useTranslate(TranslationNamespace.COMMON);

  if (headerCallToAction === HeaderCallToAction.NONE) {
    return null;
  }

  const conditionals =
    headerCallToAction === HeaderCallToAction.SIGN_UP
      ? {
          buttonLabel: t('signUp'),
          onPress: onSignUpPress,
          track: loginStarted,
        }
      : {
          buttonLabel: t('logIn'),
          onPress: onLogInPress,
          track: signupStarted,
        };

  return (
    <Button
      fill="outline"
      onPress={conditionals.onPress}
      primaryCallToAction
      track={conditionals.track}
    >
      {conditionals.buttonLabel}
    </Button>
  );
};

export { CallToActionButton };
